import React from 'react';

const AttestationTravail = ({
                                nomComplet,
                                cin = "",
                                cnss = "",
                                poste,
                                date = "",
                                dateDebut,
                                capital = "200.000,00 DH",
                            }) => (
    <div style={{padding: '20mm', fontFamily: 'Arial, sans-serif', fontSize: '12pt'}}>
        <h2 style={{textAlign: 'center'}}>GO&DEV DELIVERY CENTER</h2>
        <p style={{textAlign: 'center', fontWeight: 'bold', fontSize: '10pt'}}>
            SOCIETE A RESPONSABILITE LIMITEE A ASSOCIE UNIQUE<br/>
            AU CAPITAL DE 200.000,00 DH<br/>
            SIEGE SOCIAL : 4 RUE ARROMANE SECTEUR 9 BLOC G HAY RIAD RABAT
        </p>

        <h3 style={{textAlign: 'center', textDecoration: 'underline',  marginTop: '40px'}}>Attestation de travail</h3>

        <p style={{  marginTop: '50px'}}>
            Je soussigné, Monsieur Mahdi EL JAOUHARI, Directeur Technique de la société « GO&DEV DELIVERY CENTER »,
            société à responsabilité limitée d'associé unique, située à <strong>Villa 4 , Rue Arromane ,Rabat -Hay Riad
            10100</strong>
        </p>
        <p>
            Atteste par la présente que M. <strong>{nomComplet}</strong>, titulaire de la CIN N° <strong>{cin || "........"}</strong>,
            immatriculé à la CNSS sous le N° <strong>{cnss || "........"}</strong>, fait partie de notre personnel en qualité de
            <strong> {poste}</strong> depuis le <strong>{dateDebut}</strong>.
        </p>

        <p>Cette attestation est délivrée pour servir et valoir ce que le droit.</p>

        <p style={{marginTop: '40px'}}>
            Fait à Rabat, le {date}<br/>
            <strong>Signé :</strong><br/>
            Monsieur EL JAOUHARI Mahdi
        </p>


        <div style={{ fontSize: '12px', textAlign: 'center', marginTop: '270px' }}>
            SARL au capital de {capital} -
            CNSS: 1054596 -
            <strong>Identifiant Fiscal</strong>: 26159497 -
            TP: 25502215 -
            RC: 179995 –
            <strong>ICE</strong> : 002125743000033
        </div>
    </div>
);

export default AttestationTravail;
